import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { SessionService } from '@galaxy/core';

//Based on other apps basic auth guards.
@Injectable()
export class PublicFulfillmentOrderAuthGuard {
  constructor(
    private router: Router,
    private sessionService: SessionService,
  ) {}

  canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.sessionService.getSessionId().pipe(
      take(1),
      map((sessionId: string) => {
        if (!sessionId) {
          this.router.navigateByUrl('/error');
        }
        return true;
      }),
    );
  }
}
